import { render, staticRenderFns } from "./productos-carrito.vue?vue&type=template&id=11a94ca0&scoped=true&"
import script from "./productos-carrito.vue?vue&type=script&lang=js&"
export * from "./productos-carrito.vue?vue&type=script&lang=js&"
import style0 from "./productos-carrito.vue?vue&type=style&index=0&id=11a94ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a94ca0",
  null
  
)

export default component.exports